/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_AUTH_DETAILS, SHOW_AUTH_ERROR } from './types';

const initialState = {
  errorMessage: '',
  assignedPermissions: {},
};

export const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_AUTH_DETAILS:
      return {
        ...state,
        errorMessage: '',
        assignedPermissions: action.assignedPermissions,
      };
    case SHOW_AUTH_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};
